import { Component } from '@angular/core';
// import VersionInfo from 'src/assets/version.json';
// import { HttpClientModule } from '@angular/common/http'; @NgModule({
//   imports: [..., HttpClientModule]
// })
// import webcams from './assets/json/data.json';
import WebcamsJson from '../assets/json/data.json';
import { Title, Meta } from '@angular/platform-browser';

interface WEBCAMS {
  name: String;
  aspect: String;
  link: String;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {

  webcams: WEBCAMS[] = WebcamsJson;
  title = 'NWTCams';
  constructor(
    private titleService: Title,
    private metaTagService: Meta
  ) {
    console.log(this.webcams);
  }


  ngOnInit() {
    this.titleService.setTitle("NWT Webcams");
    this.metaTagService.addTags([
      { name: 'keywords', content: 'NWT Webcams, Northwest Territories Webcams, Hay River webcam, chan lake cam, Aklavik webcam, Freddie Carmichael airport cam, Colville Lake cam, Tommy Kochon airport cam, Fort liard cam, gameti airport cam, rae lakes airport cam, lutselk\'e airport cam, paulatuk cam, Nora Aliqatchialuk ruben airport cam, Sambaa k\'e airport cam, Tulita airport cam, Wekweeti airport cam, Wrigley airport cam, ' },
      { charset: 'UTF-8' },
      { name: 'description', content: "Webcams across Canada, highway cams, airport cams, weather cams, ski cams" }
    ]);
  }

}